import { render, staticRenderFns } from "./CardKichenSink.vue?vue&type=template&id=6f82d2e3"
import script from "./CardKichenSink.vue?vue&type=script&lang=js"
export * from "./CardKichenSink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports